import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { Alertas } from '../../core/model/alerts';
import { Page } from '../../core/model/page';
import { ResizedEvent } from '../../core/model/resized-event';
import { AlertasService } from '../../core/services/alertas.service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { SessionService } from '../../core/services/session.service';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';

@Component({
  selector: 'app-alertas',
  templateUrl: './alertas.component.html',
  styleUrls: ['./alertas.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class AlertasComponent implements OnInit {
  title: string;
  description: string;
  rootBreadcumb: string;
  childBreadcumb: string;
  page = new Page();
  showLabelCheck = false;
  modalRef: BsModalRef;

  numRemovedElements = 0;

  @ViewChild('tableAlerts') table: any;

  allAlerts: Alertas[] = [];
  allAlertsCopy: Alertas[] = [];
  alertsSelected: Alertas[] = [];
  tableColumns: any[] = [];
  hasShowIconEnvelope = false;
  mouseEnterRow: any;
  rowForShowing: Alertas[];

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay usuarios disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };

  thinking = false;

  clientId: number;
  isMulticlient: boolean;

  notificationPending: number;
  importantNotificationPending: number;

  isDocoutUser: boolean;

  constructor(
    private modalService: BsModalService,
    private authService: AuthenticationService,
    private translateService: TranslateService,
    private alertasService: AlertasService,
    private utilservice: UtilitiesService,
    private router: Router,
    private toastr: ToastrService,
    private sessionService: SessionService
  ) {
    this.page.pageNumber = 0;
    this.page.size = 10;

    this.authService.getNotificationPending().subscribe(data => {
      this.notificationPending = data;
    });

    this.authService.getImportantNotificationPending().subscribe(data => {
      this.importantNotificationPending = data;
    });
    this.clientId = this.sessionService.getClientId();
    this.isMulticlient = this.allAlerts.some(alert => alert.clientRequestId != this.clientId);
  }

  ngOnInit() {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });
    this.initTableColumns();
    this.getPaginationAlerts(0, 10);
    this.authService.getClienteName$().subscribe(rootBreadcumb => {
      this.rootBreadcumb = rootBreadcumb;
    });

    this.InitLanguage();
  }

  private initTableColumns() {
    this.tableColumns = [
      { name: this.translateService.instant('alertas.columns.Id'), prop: 'id' },
      { name: this.translateService.instant('alertas.columns.NumRequest'), prop: 'requestId' },
      { name: this.translateService.instant('alertas.columns.NumContent'), prop: 'contentId' },
      { name: this.translateService.instant('alertas.columns.Date'), prop: 'date' },
      { name: this.translateService.instant('alertas.columns.State'), prop: 'state' },
      { name: this.translateService.instant('alertas.columns.SendType'), prop: 'sendedExt' },
      { name: this.translateService.instant('alertas.columns.EmailText'), prop: 'message' },
      { name: this.translateService.instant('alertas.columns.clientName'), prop: 'clientRequestName' }
    ];

  }

  InitLanguage() {
    this.translateService.get(['alertas'])
      .subscribe(values => { this.TranslateText(values); });
  }

  TranslateText(values: any) {
    this.title = values['alertas']['title'];
    this.description = values['alertas']['description'];
    this.childBreadcumb = values['alertas']['title'];
  }

  onResizedAlerts(event: ResizedEvent): void {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  setPage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    this.getFindAlerts();
  }

  private getFindAlerts() {
    let inicio = this.page.size * this.page.pageNumber;

    if (this.numRemovedElements > 0 && inicio != 0) {
      const totalElements = this.page.totalElements - this.numRemovedElements;
      if (inicio >= totalElements) {
        inicio = inicio - this.page.size;
      }
    }

    const fin = inicio + (+this.page.size);

    this.getPaginationAlerts(inicio, fin);
  }

  private getPaginationAlerts(inicio: number, fin: number) {
    this.thinking = true;
    this.alertasService.getAlertsByUser(inicio, fin)
      .subscribe(
        data => {
          this.thinking = false;
          this.allAlerts = data.dataList;
          this.allAlerts.map(alert => alert.message = this.stripHtmlTags(alert.message));
          this.allAlertsCopy = [...this.allAlerts];
          this.page.totalElements = data.totalResults;
          this.isMulticlient = this.allAlerts.some(alert => alert.clientRequestId != this.clientId);
          this.setAlertsSelected();
          this.numRemovedElements = 0;
        }, error => {
          this.thinking = false;
          this.toastr.error('No ha sido posible obtener las alertas');
        });
  }

  private stripHtmlTags(text): string {
    return text.replace(/<[^>]*>/g, '');
  }

  private setAlertsSelected() {
    const alertsSelectedAux = [];
    this.alertsSelected.forEach(alertSelected => {
      const alertInCopy = this.allAlertsCopy.find(alert => alert.id == alertSelected.id);
      if (alertInCopy) {
        alertsSelectedAux.push(alertInCopy);
      }
    });
    this.alertsSelected = [...alertsSelectedAux];
  }

  alertsSelectedAreSameClient() {
    return !this.alertsSelected.some(alertSelected => alertSelected.clientRequestId != this.clientId);
  }


  onSelect(rows) {
    this.allAlerts = [...this.allAlertsCopy];
    this.alertsSelected = rows.selected;
    this.showLabelCheck = this.alertsSelected.length > 0 ? true : false;
    this.hasShowIconEnvelope = !this.existElementCheckedNotRead(rows);
  }

  private existElementCheckedNotRead(rows) {
    return rows.selected.some(row => row.state == 0);
  }

  bindClickToShowAlertPopup(event, popup: TemplateRef<any>) {
    if (event.type == 'mouseenter') {
      if (this.mouseEnterRow) {
        this.mouseEnterRow.mouseEnterClicked = false;
      }
      event.row.mouseEnterClicked = true;
      this.mouseEnterRow = event.row;
    }
    if (event.type == 'click' && !this.isCheckboxColumn(event)) {
      if (event.row.state == 0) {
        this.markAlertAsRead(event.row);
      }

      this.rowForShowing = event.row;
      this.openAlertModal(popup);
    }
  }

  private markAlertAsRead(row: Alertas) {
    this.alertasService.markAlertState(row.id, true)
      .subscribe(data => {
        row.state = 1;
        this.setNotifications(row.isImportant, false);
      });
  }

  private markAlertAsNotRead(row: Alertas) {
    this.alertasService.markAlertState(row.id, false)
      .subscribe(data => {
        row.state = 0;
        this.setNotifications(row.isImportant, true);
      });
  }

  markRowAsRead(row, event) {
    this.markAlertAsRead(row);
    event.stopPropagation();
  }

  markRowAsNotRead(row, event) {
    this.markAlertAsNotRead(row);
    event.stopPropagation();
  }

  private setNotifications(esImportante: number, isAdd: boolean) {
    if (esImportante == 1) {
      const count = isAdd ? this.importantNotificationPending + 1
        : this.importantNotificationPending - 1;

      this.authService.setImportantNotificationPending(count);
    } else {
      const count = isAdd ? this.notificationPending + 1
        : this.notificationPending - 1;

      this.authService.setNotificationPending(count);
    }
  }

  private isCheckboxColumn(event) {
    return event.cellElement.className.indexOf('isNoClicable') != -1;
  }

  emptyAlertsSelected() {
    if (this.alertsSelected.length == 0) {
      this.allAlerts = [...this.allAlertsCopy];
      this.alertsSelected = this.allAlerts;
      return;
    }
    this.showLabelCheck = false;
    this.alertsSelected = [];
  }

  reloadAlerts() {
    this.getFindAlerts();
  }

  mouseLeaveTable(event) {
    if (this.mouseEnterRow) {
      this.mouseEnterRow.mouseEnterClicked = false;
    }
    this.mouseEnterRow = null;
  }

  openAlertModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  closeModal() {
    this.modalRef.hide();
  }

  viewDetail(identificador: string) {
    this.router.navigate(['docout', { outlets: { contenido: ['detalle', identificador] } }]);
  }

  markNotReadSelected() {
    this.alertsSelected.forEach(alertSelected => {
      this.markAlertAsNotRead(alertSelected);
    });
  }

  markReadSelected() {
    this.alertsSelected.forEach(alertSelected => {
      this.markAlertAsRead(alertSelected);
    });
  }

  private removeAlert(row, hasReloadAlerts: boolean) {
    this.alertasService.removeAlert(row.id)
      .subscribe(data => {
        if (row.state == 0) {
          this.setNotifications(row.isImportant, false);
        }
        if (hasReloadAlerts) {
          this.getFindAlerts();
        }
      });
  }

  removeAlertRow(row, event) {
    this.numRemovedElements = 1;
    this.removeAlert(row, true);
    event.stopPropagation();
  }

  removeAlertsSelected() {
    this.alertsSelected.forEach(alertSelected => {
      this.numRemovedElements++;

      const index = this.alertsSelected.indexOf(alertSelected);
      const hasReloadAlert = index == this.alertsSelected.length - 1;
      this.removeAlert(alertSelected, hasReloadAlert);
    });
    this.alertsSelected = [];
    this.reloadAlerts();
  }

  changeRowsTable() {
    this.page.pageNumber = 0;
    this.table.recalculate();
    this.reloadAlerts();
  }

  exportAllDatas() {

    if (this.page.size >= this.page.totalElements) {
      this.downloadCSVData(this.allAlertsCopy);
      return;
    }

    this.translateService.get(['mensajes'])
      .subscribe(values => {
        this.toastr.info(values['mensajes']['downloadfileinprogress']);
      });


    this.alertasService.getAlertsByUser(0, this.page.totalElements)
      .subscribe(
        data => {
          this.downloadCSVData(data.dataList);
        },
        errorCode => {
          this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.error(values['mensajes']['errorDownloadingfile'],
                values['mensajes']['errorDownloadingfileTitle']);
            });
        });
  }

  downloadCSVData(values) {
    const csv = this.generateCSVFromValues(values);

    const fileName = this.translateService.instant('alertas.exportFileName') + '.csv';

    this.utilservice.downloadDataInCSV(fileName, csv);

  }

  private generateCSVFromValues(values: any): string {
    if (!this.isMulticlient) {
      this.tableColumns = this.tableColumns.filter(column => column.prop != 'clientRequestName');
    } else if (!this.tableColumns.some(column => column.prop == 'clientRequestName')) {
      this.tableColumns.push({ name: this.translateService.instant('alertas.columns.clientName'), prop: 'clientRequestName' });
    }

    let csvString = this.convertValuesToCSVRow(this.tableColumns.map(column => column.name));

    values.forEach(value => {
      csvString += this.convertValuesToCSVRow(this.tableColumns.map(column => this.getData(column.prop, value)));
    });

    return csvString;
  }

  private getData(prop: string, data: any): string {
    if (prop == 'sendedExt') {
      return this.translateService.instant('alertas.sendType.' + data[prop]);
    }
    if (prop == 'state') {
      const text = data[prop] == 0 ? 'notReaded' : 'readed';
      return this.translateService.instant('alertas.' + text);
    }
    if (prop == 'date') {
      return new Date(data[prop]).toLocaleString('es-ES');
    }
    if (prop == 'message') {
      return this.stripHtmlTags(data[prop]);
    }

    return data[prop];
  }

  private convertValuesToCSVRow(values: any[]): string {
    return values.join(';') + '\n';
  }

}
